import template from './iconPicker.template.html';

export default {
  template,
  bindings: {
    icon: '<',
    isVisible: '<',
    onPick: '&'
  },
controller: class controller {
    constructor(Icon) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.icons = Icon.available();
      ctrl.showPickerButton = true;
      ctrl.showIcons = false;

      /*
       * Event Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.pickIcon = function (i) {
        ctrl.showIcons = false;
        ctrl.icon = i;
        ctrl.onPick({ i: i });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        if (ctrl.isVisible === false) {
          ctrl.showPickerButton = false;
        }
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {
        if (changes.isVisible) {
          ctrl.showIcons = changes.isVisible.currentValue;
        }
      };
    }
  }
};
